module.exports = __webpack_public_path__ + "media/assets/images/blog/DALL·E_customer_service_KPI-small-3aedf4930942189012617e9f5369a60b.png";